import { PAY_BY_CARD_EVENTS } from '../../event_bus_modules/pay_by_card';
import { ARP_NAVIGATION_EVENTS } from '../../event_bus_modules/auction_registration_navigation';

$(() => {
  const SELECTORS = {
    CONTAINER: $('#auction-registration-deposit-container'),
    PROPERTY_AMOUNTS: $('#properties-table .table__cell--amount'),
    TOTAL_AMOUNT: $('#summary-table #total-amount'),
    SUB_TOTAL_AMOUNT: $('#summary-table #sub-total-amount'),
    BUYERS_FEE: $('#summary-table #buyers-fee'),
    REGISTRATION_FEE: $('#summary-table #registration-fee'),
    CURRENCY: $('input#auction-currency'),
    PAYMENT_BUTTONS: $('#buttons-container button'),
    PROPERTIES_TABLE: $('#properties-table'),
    AUCTION_ID: $('#current-auction-id'),
    PAYMENT_BUTTON_BT: $('#bank-transfer-button'),
    PAYMENT_BUTTON_PBC: $('#card-payment-button'),
  };

  const csrfToken = SELECTORS.CONTAINER.find(
    'input[name="csrfmiddlewaretoken"]'
  ).val();
  const properties = SELECTORS.PROPERTIES_TABLE.find('.table__cell');
  const propertiesIds = [];

  properties.each((i, property) => {
    let propertyId = property.getAttribute('data-auction-property-id');
    if (propertyId) {
      propertiesIds.push(propertyId);
    }
  });

  const isSelectorVisible = !!SELECTORS.CONTAINER.length;

  // Unlock PayByCard Button when response doesn't return paymentLink
  EVENT_BUS.on(
    PAY_BY_CARD_EVENTS.ARP_PAYMENT_BY_CARD_REQUEST_UNSUCCESSFUL,
    () => {
      EVENT_BUS.dispatch(ARP_NAVIGATION_EVENTS.CLEAR_LOADER);
    }
  );

  SELECTORS.PAYMENT_BUTTON_BT.on('click', () => {
    EVENT_BUS.dispatch(ARP_NAVIGATION_EVENTS.NAVIGATION_BUTTON_CLICK);
  });

  SELECTORS.PAYMENT_BUTTON_PBC.on('click', (event) => {
    const auctionId = SELECTORS.AUCTION_ID.val();
    EVENT_BUS.dispatch(PAY_BY_CARD_EVENTS.ARP_REQUEST_PAYMENT_BY_CARD, {
      auctionId,
      csrfToken,
      propertiesIds,
    });
    EVENT_BUS.dispatch(ARP_NAVIGATION_EVENTS.NAVIGATION_BUTTON_CLICK);
  });
});
